import axios from 'axios'

class ToolsQueries {
    fetchDieCutters(params) {
        return axios.get('/die-cutters/die-cutters', { params })
    }

    fetchDieCuttersOwnershipTypes(params) {
        return axios.get('/die-cutters/die-cutters/dicts/ownership-types', { params })
    }

    fetchDieCutter(id) {
        return axios.get(`/die-cutters/die-cutters/${id}`)
    }

    createDieCutter(payload) {
        return axios.post('/die-cutters/die-cutters', payload)
    }

    updateDieCutter(id, payload) {
        return axios.put(`/die-cutters/die-cutters/${id}`, payload)
    }

    deleteDieCutter(id) {
        return axios.delete(`/die-cutters/die-cutters/${id}`)
    }

    uploadDieCutterAttachment(formData, config = {}) {
        return axios.post('/die-cutters/die-cutters/file/upload', formData, {
            ...config
        })
    }

    deleteDieCutterAttachment(id) {
        return axios.delete(`/die-cutters/die-cutters/file/upload/${id}`)
    }

    fetchProductTypes(params) {
        return axios.get('/products/product-types', { params })
    }

    fetchMachineSheetFormats() {
        return axios.get('/machines/machines/dicts/machine-sheet-formats')
    }

    fetchMachines(params) {
        return axios.get('/machines/machines', { params })
    }

    fetchLocalizationRacks(localizationTypeId) {
        return axios.get(`/localization/localization-racks/${localizationTypeId}`)
    }

    fetchLocalizationShelves({ hallId, localizationTypeId, rack }) {
        return axios.get(`/localization/localization-shelves/${hallId}/${localizationTypeId}/${rack}`)
    }
}

export default new ToolsQueries()
